import { makeStyles } from "@material-ui/core/styles";
import {
  modalPapel,
  modalHero,
  modalHeroLinha,
  modalHeroIcone,
  modalHeroEtiqueta,
  modalHeroTitulo,
  modalHeroSub,
  modalFechar,
  modalCorpo,
  modalSecao,
  modalSecaoTopo,
  modalSecaoIcone,
  modalSecaoTitulo,
  modalSecaoSub,
  modalRodape,
  campoNavy,
  botaoPrimario,
  botaoSecundario,
  botaoPerigo,
  botaoPerigoCheio,
} from "../../utils/estiloNavy";

// Visual dos modais da Agenda: o mesmo "navy" dos modais de contato e fluxo.
const useEstilosModal = makeStyles((theme) => ({
  papel: modalPapel(theme, 620),
  hero: modalHero(theme),
  heroLinha: modalHeroLinha,
  heroIcone: modalHeroIcone,
  heroEtiqueta: modalHeroEtiqueta,
  heroTitulo: { ...modalHeroTitulo, whiteSpace: "normal" },
  heroSub: modalHeroSub,
  fechar: { ...modalFechar, marginLeft: "auto" },
  corpo: modalCorpo(theme),
  secao: modalSecao(theme),
  secaoTopo: modalSecaoTopo,
  secaoIcone: modalSecaoIcone,
  secaoTitulo: modalSecaoTitulo(theme),
  secaoSub: modalSecaoSub(theme),
  rodape: { ...modalRodape(theme), flexWrap: "wrap" },
  campo: campoNavy(theme),
  primario: botaoPrimario,
  secundario: botaoSecundario(theme),
  perigo: botaoPerigo,
  perigoCheio: botaoPerigoCheio,
  grade: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
  },
  grade3: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 12,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "minmax(0, 1fr)" },
  },
  dias: { display: "flex", gap: 6, flexWrap: "wrap" },
  dia: {
    width: 40,
    height: 34,
    borderRadius: 10,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.16)" : "#d0d5dd"}`,
    background: "transparent",
    cursor: "pointer",
    fontWeight: 800,
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontFamily: "inherit",
  },
  diaAtivo: {
    background: "linear-gradient(135deg,#14b8a6,#0D9488)",
    borderColor: "transparent",
    color: "#fff",
  },
  resumo: {
    fontSize: 13,
    fontWeight: 700,
    color: "#0D9488",
    padding: "8px 12px",
    borderRadius: 10,
    background: theme.palette.type === "dark" ? "rgba(20,184,166,.1)" : "#ecfdf3",
  },
  linhaInfo: {
    display: "flex",
    gap: 8,
    fontSize: 13.5,
    padding: "4px 0",
    color: theme.palette.text.primary,
    "& b": { minWidth: 110, color: theme.palette.text.secondary, fontWeight: 700 },
  },
  textoLongo: { whiteSpace: "pre-wrap", wordBreak: "break-word" },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    color: "#fff",
    backgroundColor: "rgba(255,255,255,0.12)",
    border: "1px solid rgba(255,255,255,0.22)",
    marginTop: 8,
  },
  botoesResultado: { display: "flex", gap: 8, flexWrap: "wrap" },
  resultadoAtivo: {
    background: "linear-gradient(135deg,#14b8a6,#0D9488) !important",
    color: "#fff !important",
    borderColor: "transparent !important",
  },
  faltouAtivo: {
    background: "#e53935 !important",
    color: "#fff !important",
    borderColor: "transparent !important",
  },
}));

export default useEstilosModal;
